import React from 'react';
import NotasCreditoTable from './TableNotasCredito/TableNotasCredito';

const NotasCredito = () => {
  return <NotasCreditoTable/> ;
};

export default NotasCredito;
